import MkuDropdownItem from '../dropdown/src/item';

MkuDropdownItem.install = function (Vue) {
  Vue.component(MkuDropdownItem.name, MkuDropdownItem);
};

export default MkuDropdownItem;
